import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row, Button } from 'reactstrap';
import { isNumber } from 'lodash';
import Icon from '../../common/containers/icon';
import NumberInput from '../../common/controls/numberInput';
import SegmentedPicker from '../../common/controls/segmentedPicker';
import DateTimePicker from '../../common/controls/dateTimePicker';
const JobFlangeValveInspection = ({
  flangeValveInspection,
  onChange,
  onRemove,
  index
}) => {
  const {
    pass,
    year,
    measurementA,
    measurementB,
    measurementC,
    measurementD
  } = flangeValveInspection;
  const changeYear = (value = null) => {
    if (value == null) {
      return onChange(index, 'year', null);
    }
    const y = value.substr(0, 4);
    return onChange(index, 'year', parseInt(y, 10));
  };
  const handlePass = value => onChange(index, 'pass', value);
  const handleA = value => onChange(index, 'measurementA', value);
  const handleB = value => onChange(index, 'measurementB', value);
  const handleC = value => onChange(index, 'measurementC', value);
  const handleD = value => onChange(index, 'measurementD', value);
  const handleRemove = () => onRemove(index);
  const entity = 'Job';

  // change numeric year into string.
  const y = isNumber(year) ? `${year.toString()}-06-01` : null;
  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(DateTimePicker, {
    onChange: changeYear,
    label: "Year",
    defaultValue: y,
    viewMode: "years",
    dateFormat: "YYYY"
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      height: '2px'
    }
  }), /*#__PURE__*/React.createElement(SegmentedPicker, {
    names: ['Pass', 'Fail'],
    values: [0, 1],
    allowNull: false,
    onChange: handlePass,
    value: pass
  })), /*#__PURE__*/React.createElement(Col, {
    sm: {
      size: 3,
      offset: 3
    }
  }, /*#__PURE__*/React.createElement(Button, {
    style: {
      marginTop: '27px'
    },
    size: "sm",
    className: `form-control t-jfvi-remove t-jfvi-remove-${index} tqc-control`,
    onClick: handleRemove
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "plus"
  }), " Remove Results"))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(NumberInput, {
    label: "A",
    field: "measurementA",
    onChange: handleA,
    value: measurementA,
    entity: entity
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(NumberInput, {
    label: "B",
    field: "measurementB",
    onChange: handleB,
    value: measurementB,
    entity: entity
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(NumberInput, {
    label: "C",
    field: "measurementC",
    onChange: handleC,
    value: measurementC,
    entity: entity
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(NumberInput, {
    label: "D",
    field: "measurementD",
    onChange: handleD,
    value: measurementD,
    entity: entity
  }))), /*#__PURE__*/React.createElement("hr", null));
};
JobFlangeValveInspection.propTypes = {
  index: PropTypes.number.isRequired,
  flangeValveInspection: PropTypes.shape({
    id: PropTypes.string,
    year: PropTypes.number,
    pass: PropTypes.number,
    measurementA: PropTypes.number,
    measurementB: PropTypes.number,
    measurementC: PropTypes.number,
    measurementD: PropTypes.number
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired
};
export default JobFlangeValveInspection;